import React from "react";
import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { formatChartTitle } from "../../utils";

interface HorizontalBarChartData {
  label: string;
  value: number;
  [key: string]: string | number;
}

interface HorizontalBarChartProps {
  data: HorizontalBarChartData[];
  title?: string;
  height?: number;
  color?: string;
}

export const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  data,
  title,
  height = 300,
  color = "#4DD0E1",
}) => {
  const formattedTitle = formatChartTitle(title);

  return (
    <Box sx={{ width: "100%" }}>
      {formattedTitle && (
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {formattedTitle}
        </Typography>
      )}
      <BarChart
        dataset={data}
        yAxis={[
          {
            scaleType: "band",
            dataKey: "label",
            width: 150,
            disableTicks: true,
          },
        ]}
        xAxis={[
          {
            scaleType: "linear",
            dataKey: "value",
            height: 30,
            disableTicks: true,
          },
        ]}
        series={[{ dataKey: "value", color: color }]}
        layout="horizontal"
        height={height}
        margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
        grid={{ vertical: true }}
        borderRadius={6}
      />
    </Box>
  );
};
